import React from 'react';
import { IoArrowBackOutline } from "react-icons/io5";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const BackBtn = () => {
    const history = useHistory();

    const handleBackClick = () => {
      history.goBack();
    };
  return (
    <div><h3 className=' back-btn' style={{ cursor: 'pointer' }}  onClick={handleBackClick}><IoArrowBackOutline /> </h3></div>
  )
}

export default BackBtn